import { render, staticRenderFns } from "./Rtty.vue?vue&type=template&id=8c2ec686&"
import script from "./Rtty.vue?vue&type=script&lang=ts&"
export * from "./Rtty.vue?vue&type=script&lang=ts&"
import style0 from "./Rtty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports